import { useMemo } from 'react';
import { HeaderButton, IconClose } from 'src/components/Event/styles';
import Gap from 'src/components/Gap';
import useScrollEnd from 'src/hooks/useScrollEnd';
import { isAzarJsV2 } from 'src/utils/webview';
interface CloseButtonProps {
  iconColor?: string;
  iconScrollColor?: string;
}
const CloseButton: React.FC<CloseButtonProps> = ({
  iconColor = 'white',
  iconScrollColor = 'white',
  ...props
}) => {
  const {
    isTop
  } = useScrollEnd();
  const onClickClose = () => {
    window.AzarJs?.closePopup();
  };
  const isAndroid = useMemo(() => window.AzarJs?.getPlatform() === 'ANDROID', []);
  const isIos = useMemo(() => window.AzarJs?.getPlatform() === 'IOS', []);
  const isHideClose = useMemo(
  // 구버젼앱에서는 native header에서 close 버튼이 노출되므로 웹 close버튼 제거
  () => isIos && !isAzarJsV2() || isAndroid && window.AzarJs!.getClientVersionSerial() < 2075, [isIos, isAndroid]);
  if (isHideClose) {
    return <Gap width={16} />;
  }
  return <HeaderButton onClick={onClickClose} {...props} data-sentry-element="HeaderButton" data-sentry-component="CloseButton" data-sentry-source-file="CloseButton.tsx">
      <IconClose color={iconColor} scrollColor={iconScrollColor} isTop={isTop} data-sentry-element="IconClose" data-sentry-source-file="CloseButton.tsx" />
    </HeaderButton>;
};
export default CloseButton;